module.exports = __webpack_public_path__ + "img/ethan_orlando.84202bcb.png";